import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentMethodModel} from '@app/models/payment-methods.model';
import {PrefillRegistrationModel, RegistrationRatesModel} from '@app/models/user-registration.model';
import {AddressModel} from '@app/models/addresses.model';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {AddressFormCustomComponent} from '@shared/components/address-form-custom/address-form-custom.component';
import {ContextService} from '@services/context.service';

@Component({
  selector: 'app-rapid-registration-page-2',
  templateUrl: './registration-page-2-billing.component.html',
  styleUrls: ['./registration-page-2-billing.component.scss'],
  imports: [
    SharedImports,
    AddressFormCustomComponent
  ]
})

export class RegistrationPage2BillingComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  ccType: string;
  visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
  amexpRegEx = /^(?:3[47][0-9]{13})$/;
  discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
  flipped: boolean = false;
  totalAmount: number = 0;
  inputObjState: GenericSelectModel;
  setStateId: number;
  incomingAddressBilling = {} as AddressModel;
  hasExistingPaymentMethod: boolean = false;
  cardEnding: string;
  @Input() registrationPrefillRates: RegistrationRatesModel[];
  @Output() updateData = new EventEmitter<any>();
  @Output() next = new EventEmitter<any>();
  @Input() campaignId: number;
  @Input() personPrefill: PrefillRegistrationModel;

  constructor(private formBuilder: FormBuilder, private changeDetection: ChangeDetectorRef,
              public contextService: ContextService,) {
    this.mainForm = this.formBuilder.group({
      fullName: new FormControl(null, [Validators.required]),
      cc: new FormControl(null, [Validators.required, Validators.minLength(15), Validators.maxLength(16), Validators.pattern('^[0-9 ]*$')]),
      expMonth: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('^[0-9]*$')]),
      expYear: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('^[0-9]*$')]),
      verificationNumber: new FormControl(null, [Validators.required]),
      recurring: new FormControl(null),
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      zipCode: new FormControl(null, [Validators.required]),
      useMailing: new FormControl(true),
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    this.mainForm.get('recurring').setValue(true);
    this.mainForm.get('recurring').disable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.personPrefill.ChargeDues) {
      if (this.personPrefill.PaymentMethod?.CCCardType) {
        this.hasExistingPaymentMethod = true;
        this.mainForm.get('fullName').removeValidators([Validators.required]);
        this.mainForm.get('cc').removeValidators([Validators.required]);
        this.mainForm.get('expMonth').removeValidators([Validators.required]);
        this.mainForm.get('expYear').removeValidators([Validators.required]);
        this.mainForm.get('verificationNumber').removeValidators([Validators.required]);
        this.mainForm.get('address').removeValidators([Validators.required]);
        this.mainForm.get('city').removeValidators([Validators.required]);
        this.mainForm.get('state').removeValidators([Validators.required]);
        this.mainForm.get('zipCode').removeValidators([Validators.required]);
      }
    }

    if (changes.personPrefill && this.personPrefill.PaymentMethod?.AccountNumber) {
      this.cardEnding = this.personPrefill.PaymentMethod.AccountNumber;
    }

    this.initData();
    this.totalAmount = 0;
    if (changes.registrationPrefillRates && this.registrationPrefillRates) {
      this.registrationPrefillRates.forEach(rate => {
        this.totalAmount = this.totalAmount + rate.Amount;
      });
    }
  }

  initData() {
    this.mainForm.valueChanges.subscribe(value => {
      this.personPrefill.PaymentMethod.NameOnAccount = this.mainForm.get('fullName').value;
      this.personPrefill.PaymentMethod.AccountNumber = this.mainForm.get('cc').value;
      this.personPrefill.PaymentMethod.CCExpirationMonth = this.mainForm.get('expMonth').value;
      this.personPrefill.PaymentMethod.CCExpirationYear = this.mainForm.get('expYear').value;
      this.personPrefill.PaymentMethod.CVV = this.mainForm.get('verificationNumber').value;
      this.personPrefill.PaymentMethod.MethodType = 'cc';
      this.personPrefill.PaymentMethod.Recurring = this.mainForm.get('recurring').value;
      this.personPrefill.PaymentMethod.Address1 = this.mainForm.get('address').value;
      this.personPrefill.PaymentMethod.Address2 = this.mainForm.get('address2').value;
      this.personPrefill.PaymentMethod.City = this.mainForm.get('city').value;
      this.personPrefill.PaymentMethod.StateProvinceID = this.setStateId;
      this.personPrefill.PaymentMethod.Zip = this.mainForm.get('zipCode').value;
      this.personPrefill.PaymentMethod.CountryID = 1;
      this.mainForm.get('cc').valueChanges.subscribe(dataUpdate => {
        dataUpdate = dataUpdate.replaceAll(' ', '');
        if (this.visaRegEx.test(dataUpdate)) {
          this.ccType = 'Visa';
        }
        if (this.mastercardRegEx.test(dataUpdate)) {
          this.ccType = 'Mastercard';
        }
        if (this.amexpRegEx.test(dataUpdate)) {
          this.ccType = 'amex';
        }
        if (this.discovRegEx.test(dataUpdate)) {
          this.ccType = 'Discover';
        }
      });

    });

    this.mainForm.get('useMailing').valueChanges.subscribe(dataUpdate => {
      this.useMailingAddress();
    });

    this.useMailingAddress();

  }

  useMailingAddress() {
    const tempAddress = {} as AddressModel;
    if (this.mainForm.get('useMailing').value === true) {

      //   this.changeDetection.detectChanges();
      this.mainForm.get('address').setValue(this.personPrefill.Address1);
      this.mainForm.get('address2').setValue(this.personPrefill.Address2);
      this.mainForm.get('city').setValue(this.personPrefill.City);
      this.mainForm.get('state').setValue(this.personPrefill.StateProvinceID);
      this.mainForm.get('zipCode').setValue(this.personPrefill.Zip);
      tempAddress.Zip = this.personPrefill.Zip;
      tempAddress.Address1 = this.personPrefill.Address1;
      tempAddress.Address2 = this.personPrefill.Address2;
      tempAddress.City = this.personPrefill.City;
      tempAddress.StateProvinceID = this.personPrefill.StateProvinceID;
      tempAddress.CountryID = 1;
      this.setStateId = this.personPrefill.StateProvinceID;
      this.incomingAddressBilling = tempAddress;
      this.changeDetection.detectChanges();
    } else {
      this.mainForm.get('address').setValue(null);
      this.mainForm.get('address2').setValue(null);
      this.mainForm.get('city').setValue(null);
      this.mainForm.get('state').setValue(null);
      this.mainForm.get('zipCode').setValue(null);
      tempAddress.Zip = null;
      tempAddress.Address1 = null;
      tempAddress.Address2 = null;
      tempAddress.City = null;
      tempAddress.StateProvinceID = null;
      this.incomingAddressBilling = tempAddress;
      this.setStateId = null;
    }
  }

  setAddress(addressChanges: AddressModel): void {
    if (addressChanges) {
      this.mainForm.markAsDirty();
      if (this.personPrefill.PaymentMethod === null) {
        this.personPrefill.PaymentMethod = {} as PaymentMethodModel;
      }
      this.personPrefill.PaymentMethod.CountryID = 1;
      this.personPrefill.PaymentMethod.Address1 = addressChanges.Address1;
      this.personPrefill.PaymentMethod.Address2 = addressChanges.Address2;
      this.personPrefill.PaymentMethod.City = addressChanges.City;
      this.personPrefill.PaymentMethod.StateProvinceID = addressChanges.StateProvinceID;
      this.personPrefill.PaymentMethod.Zip = addressChanges.Zip;
      this.mainForm.get('address').setValue(addressChanges.Address1);
      this.mainForm.get('address2').setValue(addressChanges.Address2);
      this.mainForm.get('city').setValue(addressChanges.City);
      this.mainForm.get('state').setValue(addressChanges.StateProvinceID);
      this.mainForm.get('zipCode').setValue(addressChanges.Zip);

    }
  }

  createNewPaymentMethod(): void {
    this.hasExistingPaymentMethod = false;
    this.useMailingAddress();
  }

  goToNextPage() {
    if (!this.hasExistingPaymentMethod) {
      this.updateData.emit(this.personPrefill);
    }

    this.next.emit();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return !(charCode < 96 && charCode > 106);
    }
    return true;

  }

  removeSpaces(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) || charCode === 190) {
      return !(charCode < 96 && charCode > 106);
    }
    return true;

  }

}
